// General
import "./hair-color-filter.scss";
import { useEffect } from "react";
// Services
import { useLazyGetJourneyQuestionsQuery } from "../../../../../services/data.service";
// Static Data
import searchConst from "../../../../../const/searchConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateHairColorData,
  updateHairColorSelected,
} from "../../../../../redux/store/searchFilterStore";
import { updateHairColorFilterDialog } from "../../../../../redux/store/dialogStore";
// Material UI
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// i18next
import { useTranslation } from "react-i18next";
// Components
import Spinner from "../../spinner/spinner";

const HairColorFilter = (props) => {
  const { type, enableTitle = true } = props;

  // API variables
  const [
    getJourneyQuestions,
    {
      data: getJourneyQuestionsData,
      error: getJourneyQuestionsErrorData,
      isFetching: getJourneyQuestionsFetching,
      isLoading: getJourneyQuestionsLoading,
      isSuccess: getJourneyQuestionsSuccess,
      isError: getJourneyQuestionsError,
    },
  ] = useLazyGetJourneyQuestionsQuery();

  // Redux variables
  const hairColorData = useSelector(
    (state) => state.searchFilter.hairColorData
  );
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Lifecycle | Mounted
  useEffect(() => {
    getJourneyQuestions(null, true);
  }, []);

  // Lifecycle | Check for update | getJourneyQuestions API Response
  useEffect(() => {
    if (getJourneyQuestionsFetching || getJourneyQuestionsLoading) {
    } else if (getJourneyQuestionsSuccess) {
      if (hairColorData?.length > 0) return;

      let temphairColorData = getHairColorData()?.map((item) => ({
        ...item,
        isSelected: false,
      }));
      dispatch(updateHairColorData(temphairColorData));
    } else if (getJourneyQuestionsError) {
    }
  }, [
    getJourneyQuestionsFetching,
    getJourneyQuestionsLoading,
    getJourneyQuestionsSuccess,
    getJourneyQuestionsError,
  ]);

  // Lifecycle | Check for update | hairColorData
  useEffect(() => {
    dispatch(updateHairColorSelected(getSelectedHairColor()));
  }, [hairColorData]);

  // Event Handlers | MUI Checkbox
  const onCheckboxChange = (id) => (event) => {
    const updatedHairColorData = hairColorData?.map((item) =>
      item.id === id ? { ...item, isSelected: event.target.checked } : item
    );
    dispatch(updateHairColorData(updatedHairColorData));
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateHairColorFilterDialog(false));
  };

  // Utility Functions
  const getHairColorData = () => {
    return getJourneyQuestionsData?.selections?.find(
      (item) => item?.category === "hair_color"
    )?.selections;
  };
  const getSelectedHairColor = () => {
    return hairColorData?.filter((item) => item.isSelected);
  };

  return (
    <div id="hair-color-filter-shared-component">
      {enableTitle && (
        <div className="dialog-header">
          <div className="title">{t("filter.hair_color")}</div>

          <div className="close-button-container">
            <CloseIcon className="close-button" onClick={onCloseDialog} />
          </div>
        </div>
      )}

      <div className="padding-container">
        {hairColorData?.length > 0 ? (
          <div
            className={`checkbox-container ${
              type === searchConst.searchFilterType.full ? "flexwrap" : ""
            }`}
          >
            {hairColorData?.map((hairColor, index) => (
              <FormGroup className="checkbox" key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      className={`custom-checkbox ${
                        type === searchConst.searchFilterType.full
                          ? "custom-checkbox-no-padding"
                          : ""
                      }`}
                      size={
                        type === searchConst.searchFilterType.full
                          ? "small"
                          : "medium"
                      }
                      checked={hairColor?.isSelected}
                      onChange={onCheckboxChange(hairColor?.id)}
                    />
                  }
                  label={
                    <span
                      className={
                        type === searchConst.searchFilterType.full
                          ? "checkbox-font"
                          : ""
                      }
                    >
                      {hairColor?.display_locale}
                    </span>
                  }
                />
              </FormGroup>
            ))}
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
};

export default HairColorFilter;
